import { createContext, useCallback, useState } from 'react'
import { getUserModePreference } from '../utils/utils'

const initialSettings = {
  hideSubscriptionStrap: false,
  themeColor: 'primary',
  mode: getUserModePreference() === 'dark' ? 'dark' : 'light',
  tenantConfig: null,
  skin: 'default',
  removePadding: false,
  navHidden: false,
  appBar: 'fixed',
  appBarHidden: false,
  appBarBlur: false,
  contentWidth: 'boxed',
  sidePanel: {
    opened: false,
    hidden: false,
    expanded: true
  },
  secondaryNavBarConfig: {
    show: true,
    showBackButton: false
  },
  breadcrumbs: null
}

export const SettingsContext = createContext({
  setSettings: () => null,
  saveSettings: () => null,
  settings: initialSettings
})

export const SettingsProvider = ({ children }) => {
  // ** State
  const [settings, setSettings] = useState({ ...initialSettings })

  const saveSettings = useCallback((updatedSettings) => {
    setSettings((prev) => ({ ...prev, ...updatedSettings }))
  }, [])

  return (
    <SettingsContext.Provider value={{ settings, saveSettings, setSettings }}>
      {children}
    </SettingsContext.Provider>
  )
}
